// components/SampleDataLoader.jsx
import React, { useState } from "react";
import {
  useLoadSampleData,
  useSampleDataValidation,
} from "../hooks/useSampleDataQueries.jsx";
import { useToast } from "../context/ToastContext.jsx";
import ConfirmationModal from "./ConfirmationModal.jsx";

const SampleDataLoader = ({
  tvId,
  tvName,
  currentTVData,
  onSampleDataLoad, // 🎯 새로운 prop: 샘플 데이터 로드 시 부모에게 알려주는 콜백
  disabled = false,
}) => {
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const { toastSuccess, toastError } = useToast();

  // React Query 훅들
  const loadSampleDataMutation = useLoadSampleData();
  const validateTV = useSampleDataValidation();

  // 샘플 데이터는 이미 올바른 형식으로 생성되므로 간단한 검증만 수행
  const logSampleDataInfo = (sampleTVData) => {
    if (!sampleTVData) {
      return sampleTVData;
    }

    // contents 배열이 제대로 생성되었는지 확인
    // if (sampleTVData.contents && Array.isArray(sampleTVData.contents)) {
    //   sampleTVData.contents.forEach((item, index) => {
    //     console.log(`🎯 Content ${index + 1}:`, {
    //       name: item.name,
    //       contentType: item.content?.contentType,
    //       type: item.content?.type,
    //       url: item.content?.url,
    //     });
    //   });
    // }

    return sampleTVData;
  };

  // 버튼 클릭 처리
  const handleButtonClick = () => {
    // async 제거
    if (!tvId) {
      toastError("먼저 현황판을 선택하세요.");
      return;
    }

    // API 호출 없이 바로 모달 표시
    setShowConfirmModal(true);
  };

  // 샘플 데이터 로드 실행 - API 호출 없이 브라우저 상태만 업데이트
  const handleConfirmLoad = async () => {
    try {
      // 샘플 데이터 생성 (API 호출 없음)
      const result = await loadSampleDataMutation.mutateAsync({
        tvId,
        currentTVData,
      });

      if (result.success) {
        // 샘플 데이터 검증 (이미 올바른 형식으로 생성됨)
        const validatedData = logSampleDataInfo(result.sampleTVData);

        // 부모 컴포넌트에 샘플 데이터 전달 (브라우저 상태 업데이트)
        if (onSampleDataLoad && typeof onSampleDataLoad === "function") {
          onSampleDataLoad(validatedData);
        }

        // 성공 메시지
        toastSuccess(
          `${tvName || tvId}에 샘플 컨텐츠와 배경음악이 로드되었습니다.`
        );

        // 모달 닫기
        setShowConfirmModal(false);
      } else {
        throw new Error(result.message || "샘플 데이터 로드에 실패했습니다.");
      }
    } catch (error) {
      toastError(`샘플 컨텐츠 로드 실패: ${error.message}`);
      setShowConfirmModal(false);
    }
  };

  // 모달 취소
  const handleCancelLoad = () => {
    setShowConfirmModal(false);
  };

  // 로딩 상태
  const isLoading = loadSampleDataMutation.isPending;

  return (
    <>
      <button
        onClick={handleButtonClick}
        disabled={disabled || isLoading}
        style={{
          background: isLoading
            ? "linear-gradient(45deg, #a0a0a0, #808080)"
            : "linear-gradient(45deg, #ff6b9d, #ff8fab)",
          color: "white",
          border: "none",
          borderRadius: "20px",
          padding: "6px 14px",
          fontSize: "12px",
          fontWeight: "500",
          cursor: disabled || isLoading ? "not-allowed" : "pointer",
          transition: "all 0.2s",
          display: "flex",
          alignItems: "center",
          gap: "6px",
          boxShadow: isLoading
            ? "0 2px 8px rgba(160, 160, 160, 0.3)"
            : "0 2px 8px rgba(255, 107, 157, 0.3)",
          opacity: disabled || isLoading ? 0.7 : 1,
        }}
        onMouseOver={(e) => {
          if (!disabled && !isLoading) {
            e.target.style.transform = "translateY(-1px)";
            e.target.style.boxShadow = "0 4px 12px rgba(255, 107, 157, 0.4)";
          }
        }}
        onMouseOut={(e) => {
          if (!disabled && !isLoading) {
            e.target.style.transform = "translateY(0)";
            e.target.style.boxShadow = "0 2px 8px rgba(255, 107, 157, 0.3)";
          }
        }}
      >
        🎯 {isLoading ? "로딩 중..." : "샘플 컨텐츠 로드"}
      </button>

      {/* 확인 모달 */}
      <ConfirmationModal
        isOpen={showConfirmModal}
        message={`샘플 컨텐츠와 배경음악을 로드하시겠습니까?\n기존 설정된 컨텐츠와 배경음악은 사라집니다.`}
        onConfirm={handleConfirmLoad}
        onCancel={handleCancelLoad}
        isDelete={false}
        confirmText="브라우저에 로드"
        cancelText="취소"
      />
    </>
  );
};

export default SampleDataLoader;
